<template>
  <v-row justify="center">
    <v-dialog :value="dialog" max-width="500" @input="closeConfirmModal">
      <v-card>
        <v-card-title class="headline accent--text pb-2" style="word-break: break-word">
          Подтверждение удаления
        </v-card-title>

        <v-card-text outlined tile class="border-top pb-0">
          <v-container>
            <v-row>
              <v-col cols="12" class="pa-0 pt-3">
                <p class="accent--text">
                  {{ message }}
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="px-6 mt-0">
          <v-spacer />
          <v-btn text color="lightGrey" @click="closeConfirmModal">
            Отмена
          </v-btn>
          <v-btn
            color="error"
            text
            :loading="loading"
            @click="confirm"
          >
            Удалить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    loading: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: '',
    },
  },

  methods: {
    confirm() {
      this.$emit('confirm')
    },

    closeConfirmModal() {
      this.$emit('closeConfirmModal')
    },
  },
}
</script>

<style lang="scss" scoped>
.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.theme--light.v-btn.v-btn--disabled {
  color: #dadada !important
}
</style>
